import React, { useState } from 'react';

/**
 * Avatar with initials fallback.
 *
 * @param {string} src — image URL
 * @param {string} name — full user name
 * @param {number} size — diameter in pixels
 */
export default function Avatar({ src, name, size = 40 }) {
  const [imgError, setImgError] = useState(false);

  // Get at most two initials
  const initials = (name || 'U')
    .split(' ')
    .map(part => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  // Generate a pastel color based on the name
  const stringToColor = str => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      // simple hash
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 60%, 70%)`;
  };

  // If no src or error loading, render initials
  if (!src || imgError) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: stringToColor(name || 'User'),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: '600',
          fontSize: size * 0.4,
          userSelect: 'none',
        }}
      >
        {initials}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      onError={() => setImgError(true)}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover',
      }}
    />
  );
}
